import { defineAsyncComponent } from 'vue'
export const islandComponents = import.meta.client ? Object.create(null) : Object.assign(Object.create(null), {

})
export const pageIslandRoutes = import.meta.client ? Object.create(null) : Object.assign(Object.create(null), {

})
export const providePageIslandDepth = () => {}